export const toolbarInitialState = {
  downloadingPDF: false,
  isSocialMediaButtonDialogOpen: false
}

export type ToolbarState = typeof toolbarInitialState
